<template>
    <div class="document-modal document input-full-width">
        <div class="modal-header">
            <h2 class="text-center">{{editedData.name}}</h2>
        </div>

        <div class="form">
            <div class="grid-x align-items">
                <div class="cell small-2 medium-1 large-1 flexbox-center">
                    <icon class="bubble small-svg" name="bubble" />
                </div>
                <div class="cell auto">
                    <div class="grid-x align-items">
                        <div class="cell small-5 medium-3 large-3">
                            <label for="documentNote">Note</label>
                        </div>
                        <div class="cell auto">
                            <textarea v-autogrow="15" type="text" rows="4" cols="30" id="documentNote" ref="documentNote" style="word-wrap: break-word;" v-model="editedData.description"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" @click="updateDocument()">Gem</button>
                <button type="button" class="button-naked" @click="closeModal()">Fortryd</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'document-modal-description',
    props: {
        data: Object
    },
    data () {
        return {
            editedData: Object.assign({}, this.data)
        }
    },
    methods: {
        closeModal () {
            this.$emit('close')
        },
        updateDocument () {
            this.data.description = this.editedData.description
            this.data.updating = true
            this.closeModal()
        }
    },
    created () {
        this.data.updating = false
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/fileupload/document-modal-description.vue